import React, { useEffect, useState } from "react";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  TableContainer,
  TableHead,
  Box,
  Typography,
  Radio,
} from "@mui/material";
import moment from "moment";
import Iconify from "../iconify";
import ResultButton from "./ResultButton";
import { put } from "src/utils/networkUtils";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
const PendingDrawTable = ({ rows, handleOpenMenu }) => {
  const [selectedRows, setSelectedRows] = useState({});

  useEffect(() => {
    const initial = {};
    rows.forEach((row) => {
      initial[row.prizeDrawId] = row.isCompleted;
    });
    setSelectedRows(initial);
  }, [rows]);

  const handleOnChange = async (event, rowId, prizes) => {
    try {
      if (prizes.length === 0) return;
      const userIds = prizes
        ?.filter((p) => p.userId != null)
        .map((p) => p.userId)
        .join(",");
      setSelectedRows((prev) => ({
        ...prev,
        [rowId]: event.target.checked,
      }));

      const resp = await put(`/admin/prize-draws/close/${rowId}`, {
        isCompleted: true,
        specificUserIds: userIds,
        auditory: "userids",
        publishAt: moment().format(dateFormat),
      });
      if (resp.success) {
        window.location.reload(true);
      }
    } catch (error) {
      setSelectedRows((prev) => ({
        ...prev,
        [rowId]: !event.target.checked,
      }));
    }
  };
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Draw Date</TableCell>
            <TableCell>Prize</TableCell>
            <TableCell>Username</TableCell>
            <TableCell>No. of Tickets</TableCell>
            <TableCell></TableCell>
            <TableCell>Close</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map(
            (row, index) =>
              row !== null &&
              row !== undefined && (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {row.prizeDrawId}
                  </TableCell>

                  <TableCell>
                    <Typography variant="subtitle2">{row.title}</Typography>
                  </TableCell>

                  <TableCell>
                    {moment(row.drawDate).format("ddd MMM D, YYYY")}
                  </TableCell>

                  <TableCell>
                    {row?.prizes?.length > 0 &&
                      row?.prizes?.map((prize, index) => {
                        const isLast = index === row.prizes.length - 1;
                        return (
                          <Box
                            sx={{
                              maxWidth: 200,
                              marginBottom: isLast ? 0 : 5,
                            }}
                          >
                            {prize.Title || "No prize description"}
                          </Box>
                        );
                      })}
                  </TableCell>

                  <TableCell>
                    {row?.prizes?.length > 0 &&
                      row?.prizes?.map((prize, index) => {
                        const isLast = index === row.prizes.length - 1;
                        return (
                          <Box
                            sx={{ maxWidth: 200, marginBottom: isLast ? 0 : 5 }}
                          >
                            {prize.username || "--"}
                          </Box>
                        );
                      })}
                  </TableCell>

                  <TableCell>
                    {row?.prizes?.length > 0 &&
                      row?.prizes?.map((prize, index) => {
                        const isLast = index === row.prizes.length - 1;
                        return (
                          <Box
                            sx={{ maxWidth: 200, marginBottom: isLast ? 0 : 5 }}
                          >
                            {prize.amount || "--"}
                          </Box>
                        );
                      })}
                  </TableCell>
                  <TableCell>
                    {row?.prizes?.length > 0 &&
                      row?.prizes?.map((prize, index) => {
                        const isLast = index === row.prizes.length - 1;
                        return (
                          <Box sx={{ marginBottom: isLast ? 0 : 5 }}>
                            <ResultButton
                              data={prize}
                              prizeDrawId={row.prizeDrawId}
                            />
                          </Box>
                        );
                      })}
                  </TableCell>
                  <TableCell>
                    <Radio
                      checked={!!selectedRows[row.prizeDrawId]}
                      onChange={(e) =>
                        handleOnChange(e, row.prizeDrawId, row?.prizes)
                      }
                      size="small"
                      sx={{ padding: 0.5 }}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="large"
                      color="inherit"
                      onClick={(event) => {
                        handleOpenMenu(event, row);
                      }}
                      id={row.prizeDrawId}
                    >
                      <Iconify icon={"eva:more-vertical-fill"} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PendingDrawTable;
